import { ZastosowanieCategoryAttributeType } from "./ZastosowanieCategory";

export type Property = string | number | DecimalProperty | string[] | null;

export class DecimalProperty {
  value: number = 0;
  tolerance: number = 0;
}

export class DecimalRangeProperty {
  min: number = 0;
  max: number = 0;
}

export const propertyToStringFn: {
  [keys in ZastosowanieCategoryAttributeType]: (prop: any) => string;
} = {
  decimal: (val: DecimalProperty) => val.value.toString(),
  integer: (val: number) => val.toString(),
  multipleChoice: (options: string[]) => options.join(", "),
  singleChoice: (val: string) => val,
  string: (val: string) => val,
  decimalRange: (val: any) => val.min.toString() + " - " + val.max.toString(),
};
